import { render, staticRenderFns } from "./Setupmain.vue?vue&type=template&id=7cbecaec&"
import script from "./Setupmain.vue?vue&type=script&lang=js&"
export * from "./Setupmain.vue?vue&type=script&lang=js&"
import style0 from "./Setupmain.vue?vue&type=style&index=0&id=7cbecaec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports